export default __webpack_public_path__ + "static/media/main-slider-know-about-health.c0009b24.png";